<section
  class="description-section w-100 bg-white d-flex justify-content-center align-items-center"
>
  <div
    class="w-80 h-100 d-flex flex-column gap-3 align-items-center justify-content-center"
  >
    <h2 class="h2-text fs-3-text text-center fw-semibold">
      Estimez votre bien immobilier au prix le plus juste du marché avec la base
      de données Perval
    </h2>
    <p class="text-center fs-5-text d-flex flex-column">
      <span class="fw-bold"
        >Face à des clients exigeants, distinguez-vous avec des données
        immobilières fiables, précises et les plus récentes du marché.</span
      ><span
        >Perval, outil reconnu en estimation immobilière professionnelle, donne
        accès aux données immobilières issues des actes notariaux.</span
      ><span>
        C’est la référence des professionnels de l’immobilier pour consulter 100
        % des ventes enregistrées en France</span
      ><span>
        y compris Alsace-Lorraine (hors Île-de-France), dès 6 semaines après la
        signature de l’acte.</span
      ><span>
        Sélectionnez les ventes réellement comparables, même sur des secteurs
        que vous ne maîtrisez pas encore, et appuyez vos estimations sur des
        données enrichies et qualifiées.</span
      >
    </p>

    <p class="landing-green-color fs-4-text text-center fw-bold">
      Utilisée par les notaires, experts et agents immobiliers, la base Perval
      sécurise vos estimations.
    </p>
  </div>
</section>
